import React, { Component } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle2, MessageCircle } from 'lucide-react';
import { Header } from '../components/Header';
import { Button } from '../components/ui/Button';
export function Success() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as {
    categoryName: string;
    requestId: string;
  } | null;
  // Fallback if accessed directly without state
  const categoryName = state?.categoryName || 'Home Service';
  const requestId = state?.requestId || Date.now().toString();
  const whatsappNumber = '60123456789'; // Placeholder
  const message = encodeURIComponent(`Hi Hands, I submitted a request for ${categoryName}. Request ID: ${requestId}`);
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-214">
      <Header data-id="element-215" />

      <main className="flex-1 max-w-md mx-auto w-full px-4 py-12 flex flex-col items-center justify-center text-center" data-id="element-216">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 w-full" data-id="element-217">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-218">
            <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-219" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-220">
            Request Submitted!
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-221">
            Thank you. Our team has received your request for{' '}
            <span className="font-semibold text-gray-900" data-id="element-222">{categoryName}</span>{' '}
            and will contact you shortly.
          </p>

          <div className="space-y-3" data-id="element-223">
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-224">
              <Button variant="whatsapp" fullWidth className="flex items-center justify-center gap-2" data-id="element-225">
                <MessageCircle className="w-5 h-5" data-id="element-226" />
                Chat on WhatsApp
              </Button>
            </a>

            <Button variant="outline" fullWidth onClick={() => navigate('/')} data-id="element-227">
              Submit Another Request
            </Button>
          </div>

          <p className="text-xs text-gray-400 mt-6" data-id="element-228">Request ID: {requestId}</p>
        </div>
      </main>
    </div>;
}